'use client';
import Image from 'next/image';
import { WaitlistForm } from '@/components/waitlist/waitlist-form';

export default function Waitlist() {
  return (
    <div className="min-h-screen bg-[#eae7e0]">
      <div className="max-w-2xl mx-auto px-4 sm:px-8 py-8 sm:py-12">
        {/* Header */}
        <div className="flex justify-center mb-6">
          <Image
            width={240}
            height={80}
            src={'/logo2.svg'}
            alt={'Wee Amici logo'}
          />
        </div>
        <div className="text-left mb-8">
          <h1 className="text-2xl font-bold mb-2">Waitlist Application</h1>
          <p className="text-gray-600">
            Please complete to gain access to the platform
          </p>
        </div>

        <WaitlistForm />
      </div>
    </div>
  );
}
